import React from 'react';
import { StyledWrapper } from "./Wrapper.styles";

export const Wrapper:React.FC = (props) => {
    return <StyledWrapper {...props} />
};
